import moment from "moment";

export class SalayAdj {
    StaffID;
    StaffName;
    CompCode;
    JobTitle;
    EmpType;
    DateTx;
    Seq;
    AdjAdd;
    IncType;
    IncSubType;
    Particulars;
    Amt;
    SysGen;
    AprvBy;
    AprvByName;
    DateAprv;
    DateAdd;
    DateModify;
    AddBy;
    ModifyBy;
    constructor() {
        {
            this.StaffID = "";
            this.StaffName = "";
            this.CompCode = "";
            this.JobTitle = "";
            this.EmpType = "";
            this.DateTx = moment(new Date()).format("YYYY-MM-DD");
            this.Seq = 0;
            this.AdjAdd = true;
            this.IncType = "";
            this.IncSubType = "";
            this.Particulars = "";
            this.Amt = 0;
            this.SysGen = false;
            this.AprvBy = "";
            this.AprvByName = "";
            this.DateAprv = moment(new Date()).format("YYYY-MM-DD");
            this.DateAdd = moment(new Date()).format("YYYY-MM-DD");
            this.DateModify = moment(new Date()).format("YYYY-MM-DD");
            this.AddBy = "";
            this.ModifyBy = "";
        }
    }
}



// WEBPACK FOOTER //
// ./src/model/SalayAdj.js